import Container from '@/containers/ShowAttachment'

const Page = () => {
  return <Container />
}

export default Page
